import { render, staticRenderFns } from "./CompanyRestorationTab.vue?vue&type=template&id=009a7a1c&scoped=true&"
import script from "./CompanyRestorationTab.vue?vue&type=script&lang=js&"
export * from "./CompanyRestorationTab.vue?vue&type=script&lang=js&"
import style0 from "./CompanyRestorationTab.vue?vue&type=style&index=0&id=009a7a1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009a7a1c",
  null
  
)

export default component.exports